<template>
  <b-button @click="clearState">Clear state</b-button>
</template>

<script>
export default {
  methods: {
    clearState() {
      console.log(window.localStorage)
      window.localStorage.clear()
    },
  },
}
</script>
